import React from 'react';

export const CheckMark = ({ width = 18, height = 18, color = '#90909E' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m17.334 3.317-9.508 9.516L4.293 9.3l1.175-1.175 2.358 2.358L16.16 2.15l1.175 1.167Zm-1.841 4.2c.108.475.175.975.175 1.483A6.665 6.665 0 0 1 9 15.667 6.665 6.665 0 0 1 2.334 9a6.665 6.665 0 0 1 6.667-6.667 6.6 6.6 0 0 1 3.567 1.042l1.2-1.2A8.25 8.25 0 0 0 9 .667 8.336 8.336 0 0 0 .668 9c0 4.6 3.733 8.333 8.333 8.333S17.334 13.6 17.334 9c0-.992-.183-1.942-.5-2.825l-1.341 1.342Z"
      fill={color}
    />
  </svg>
);
